<script setup lang="ts">
import type { SignalItem } from "@/store/search/signals";

defineProps<{ items: readonly SignalItem[] }>();
</script>

<template>
  {{ $t("signals.title") }}
  <div v-for="item in items" :key="item.id" class="shortcut">
    {{ item.label }}
  </div>
</template>
